import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Content from "../common/Content";
import { scrollToTop } from "../common/GeneralMethod";
import { useLoading } from "../hooks/useLoading";
import Footer from "../common/Footer";
import Header from "../common/Header";
import LogoContent from "../common/LogoContent";

const PrivacyPolicy = ({Header}) => {
  const location = useLocation();
  const { startLoading, stopLoading} = useLoading()
  const [policyData, setPolicyData] = useState([]);

  useEffect(() => {
      scrollToTop();

    // const fetchData = async () => {
    //   startLoading()
    //   await axios({
    //     method: "get",
    //     url: process.env.REACT_APP_API_URL + apiName,
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //   })
    //     .then((response) => {
    //       // console.log(response)
    //       setPolicyData([...response.data.data]);
    //       stopLoading()

    //       //console.log(response.data.data);
    //     })
    //     .catch(function (err) {
    //       // console.log(err);
    //       stopLoading()
    //     });
    // };
    // fetchData();
  }, []);

  return (
    <div>
      {/* Header */}
      {Header!=="No"?<header className="navbar-light header-sticky">
        <nav className="navbar navbar-expand-xl">
          <div className="container">
            <LogoContent></LogoContent>
          </div>
        </nav>
      </header>:null}
      <main>
        <div className="main-content my-5 py-3">
          <div className="privacyPolicy">
           <div className="container">
           <h6 className="mb-3">Privacy Policy Effective Date: 26 Dec 2024</h6>
<p>Welcome to Cabkro! Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you use our cab booking application, website, and related services (“Services”).</p>

<h6>1. Information We Collect</h6>
<p><strong>1.1 Personal Information</strong></p>
<ul>
  <li>Full Name</li>
  <li>Mobile Number</li>
  <li>Email Address</li>
  <li>Pickup and Drop Locations</li>
  <li>Billing Address (if required)</li>
</ul>

<p><strong>1.2 Technical & Usage Data</strong></p>
<ul>
  <li>Device type, operating system, browser</li>
  <li>IP address, location (if permitted)</li>
  <li>App usage and interaction data</li>
</ul>

<p><strong>1.3 Data from Third-Party Platforms</strong></p>
<ul>
  <li>Information you allow us to access from third-party logins (e.g., Google/Facebook)</li>
</ul>

<h6>2. How We Use Your Information</h6>
<p>We use your information to:</p>
<ul>
  <li>Book and manage cab rides</li>
  <li>Send ride confirmations and updates</li>
  <li>Process payments securely</li>
  <li>Provide customer support</li>
  <li>Improve our platform and user experience</li>
  <li>Comply with legal and regulatory requirements</li>
</ul>

<h6>3. Data Sharing</h6>
<p>We only share your information with:</p>
<ul>
  <li>Drivers and fleet partners to fulfill your booking</li>
  <li>Payment processors for secure transactions</li>
  <li>Government or legal authorities when required</li>
  <li>Trusted third parties who help us operate our services (under confidentiality)</li>
</ul>

<h6>4. Data Retention</h6>
<p>We retain your personal data only for as long as needed for the purposes set out in this policy, or as required by law.</p>

<h6>5. Data Security</h6>
<p>We implement strong safeguards to protect your personal data. While no system is completely secure, we strive to use best practices to ensure your information is safe.</p>

<h6>6. Your Privacy Rights</h6>
<p>You have the right to:</p>
<ul>
  <li>Access and update your personal details</li>
  <li>Request deletion of your data (where legally allowed)</li>
  <li>Withdraw consent for marketing communications</li>
</ul>
<p>To exercise any of these rights, email us at <strong>contactus@cabkro.com</strong>.</p>

<h6>7. Cookies & Tracking</h6>
<p>We use cookies and similar technologies to improve your browsing experience and track usage analytics. You can control cookie settings from your browser preferences.</p>

<h6>8. Third-Party Links</h6>
<p>Our app or website may contain links to other sites. We are not responsible for their privacy practices. Please review their policies when you visit them.</p>
<h6>11. Disclaimer</h6>
<p>While we strive to ensure all information on our website and services is accurate and current, Cabkro does not make any warranties or representations regarding the completeness, reliability, or accuracy of this content. Use of the website is at your own discretion and risk. To the extent permitted by law, Cabkro is not liable for any losses or damages resulting from your use of this site or its contents.</p>
<p>All content on this platform—including text, graphics, logos, and images—is protected by copyright and other intellectual property rights. You may not reproduce, distribute, or reuse any part of this site without prior written consent from Cabkro.</p>

<h6>12. User Account Deletion</h6>
<p>If you wish to delete your Cabkro account, please send your request to <strong>support@cabkro.com</strong>.</p>
<p>Your request will be processed once any active or pending bookings linked to your account are completed or cancelled. After that, your personal data will be permanently deleted from our systems. Please note that certain transaction records may be retained for legal and regulatory reasons, but all personal identifiers will be removed or masked from such records.</p>

<h6>9. Policy Updates</h6>
<p>We may update this Privacy Policy occasionally. We’ll notify users of major changes and post the latest version with an updated “Effective Date.”</p>

<h6>10. Contact Information</h6>
<p>If you have any questions or concerns, feel free to reach us:</p>
<ul>
  <li><strong>Email:</strong> contactus@cabkro.com</li>
  <li><strong>Phone:</strong> +91 9997325252</li>
  <li><strong>Address:</strong> Mathura, Uttar Pradesh, India</li>
</ul>

<p>Thank you for choosing Cabkro. We value your trust and are committed to safeguarding your privacy.</p>

           </div>
            </div>
          </div>
      </main>

      {/* <Footer></Footer> */}
      {/* <BackToTop></BackToTop> */}
    </div>
  );
};

export default PrivacyPolicy;
